import CryptoJS from 'crypto-js';

const AES_SECRET_KEY = import.meta.env.VITE_AES_SECRET_KEY;

// ─── Encryption / Decryption ──────────────────────────────────────────────────

function AESencryption(data) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), AES_SECRET_KEY).toString();
}

function AESdecryption(cipherText) {
    const bytes = CryptoJS.AES.decrypt(cipherText, AES_SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
}

// ─── Session Storage ──────────────────────────────────────────────────────────

export function sessionDataEnc(key, val) {
    sessionStorage.setItem(btoa(key), AESencryption(val));
}

export function sessionDataDec(key) {
    const storedData = sessionStorage.getItem(btoa(key));
    return storedData ? AESdecryption(storedData) : null;
}